module.exports = __webpack_public_path__ + "img/126.8.6906979d.png";